import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from '../../interfaces/menu-item';
import { OrderService } from '../../services/order.service';
import { item } from '../../item';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-lunch-item',
  templateUrl: './lunch-item.component.html',
  styleUrls: ['./lunch-item.component.scss']
})
export class LunchItemComponent implements OnInit {
  @Input() item: MenuItem;
  @Input() i: any;
  now = new Date();
  public currentTime = moment.tz(this.now, 'Asia/Kathmandu').format('HH:mm:ss');
  timeRightNow = moment(this.currentTime, 'h:mma');
  endTime = moment('11:30am', 'h:mma');
  public canEdit = this.timeRightNow.isBefore(this.endTime);

  constructor(private _orderService: OrderService) {
  }

  ngOnInit() {}

  addQuickOrder(_item: item) {
    this._orderService.addQuickOrder(_item);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/lunch-item/lunch-item.component.ts